// extracted by mini-css-extract-plugin
export default {"page__404":"NotFound_page__404__m0WPd"};